import React from 'react';

import {
  BulkAssemblyConstructsStructuredTableMetadata,
  BulkAssemblyConstructsStructuredTableRowMetadata,
} from 'molbio/bulk-assembly/tables/BulkAssemblyConstructsStructuredTableAdapter';
import ActionFunctionButton from 'notebook/structured-tables/action-functions/ActionFunctionButton';
import makeCustomButtonActionFunction from 'notebook/structured-tables/action-functions/makeCustomButtonActionFunction';
import unsupportedOverflowMenuItem from 'notebook/structured-tables/action-functions/unsupportedOverflowMenuItem';
import {StructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';

export function renderAutopopulateConstructsButton({
  structuredTable,
}: {
  structuredTable: StructuredTable<
    BulkAssemblyConstructsStructuredTableMetadata,
    BulkAssemblyConstructsStructuredTableRowMetadata
  >;
}): JSX.Element {
  const {autopopulateButtonError} = structuredTable.metadata;
  return (
    <ActionFunctionButton
      buttonStyle={ButtonStyle.PRIMARY}
      disabled={autopopulateButtonError != null}
      buttonText="Autopopulate"
      onClick={structuredTable.metadata.onAutopopulate}
      tooltip={
        autopopulateButtonError ?? 'Create constructs involving all possible combinations of fragments.'
      }
      tooltipDisabled={false}
    />
  );
}

export const autopopulateConstructsActionFunction = makeCustomButtonActionFunction<
  BulkAssemblyConstructsStructuredTableMetadata,
  BulkAssemblyConstructsStructuredTableRowMetadata
>({
  getHidden: (params) => params.structuredTable.metadata.isReadOnly,
  renderToolbarButton: renderAutopopulateConstructsButton,
  renderOverflowMenuItem: unsupportedOverflowMenuItem,
});
